import styled from 'styled-components';

const ReminderNoticeText = styled.span`
  font-weight: bold;
`;

export default ReminderNoticeText;
